/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * FastMile API
 * OpenAPI spec version: v1
 */

export type BillingIntervalEnum =
  (typeof BillingIntervalEnum)[keyof typeof BillingIntervalEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillingIntervalEnum = {
  NUMBER_1: 1,
  NUMBER_12: 12,
} as const
